import { authStore } from "./store";
import type {
  AuthProfile,
  AuthState,
  AuthStore,
  AuthTill,
  AuthUnattended
} from "./store.types";

// Selectors
const storeSelector = (state: AuthStore): AuthState => state as AuthState;
const tokenSelector = (state: AuthStore): AuthState["token"] => state.token;
const statusSelector = (state: AuthStore): AuthState["status"] => state.status;

// Getters
export function getAuthToken(): AuthState["token"] {
  return tokenSelector(authStore.getState());
}
export function getAuth(): AuthState {
  return storeSelector(authStore.getState());
}
export function getAuthStatus(): AuthState["status"] {
  return statusSelector(authStore.getState());
}

/**
 * Check if the auth state has profile data (profile or unattended).
 * Use this for type narrowing when you need access to profile properties.
 */
export function isProfileAuth(
  auth: AuthState
): auth is AuthProfile | AuthUnattended {
  return auth.status === "profile" || auth.status === "unattended";
}

/**
 * Check if the current auth status has till data (till, profile, or unattended).
 * These statuses have tillId, moduleId, schoolId, etc. set.
 */
export function hasTillData(
  status: AuthState["status"]
): status is "till" | "profile" | "unattended" {
  return status === "till" || status === "profile" || status === "unattended";
}

/**
 * Check if the auth state has till data (till, profile, or unattended).
 * Use this for type narrowing when you need access to till properties.
 */
export function isTillAuth(
  auth: AuthState
): auth is AuthTill | AuthProfile | AuthUnattended {
  return (
    auth.status === "till" ||
    auth.status === "profile" ||
    auth.status === "unattended"
  );
}
